import { RequestModel } from '../shopping-cart/request-model.model';

export class JsonRequestModel {
  caqhId: string;
  country: string;
  practiceName: string;
  firstName: string;
  providerType: string;
  lastName: string;
  npi1Id: string;
  providerId: string;
  taxId: string;
  requestType: string;
  gatewayMedicaid: boolean;
  requestTypeOpt: string;
  effectiveDate: string;
  states: string[];
  requestDetails: string;
  middleInitial: string;

  constructor(request: RequestModel) {
    this.caqhId = request.caqhId;
    this.country = request.country;

    if (request.effDate) {
      const d = new Date(request.effDate);
      let month = '' + (d.getMonth() + 1);
      let day = '' + d.getDate();
      const year = d.getFullYear();

      if (month.length < 2) {
        month = '0' + month;
      }

      if (day.length < 2) {
        day = '0' + day;
      }

      this.effectiveDate = [year, month, day].join('-');
    }

    this.firstName = request.name;
    this.lastName = request.lastName;
    this.middleInitial = request.middleInitial;
    this.states = request.state ? request.state.length > 0 ? request.state : null : null;
    this.gatewayMedicaid = request.gateway;
    this.npi1Id = request.NPI;
    this.practiceName = request.name;
    this.providerType = request.providerType;
    this.providerId = request.providerID;
    this.requestType = request.requestType;
    this.taxId = request.taxID;
    this.requestTypeOpt = request.reasonForResignation ? request.reasonForResignation : request.maintenanceType;
    this.requestDetails = request.requestDetails;
  }
}
